export default {
  english: {
    editProfile: 'Edit profile',
    cancel: 'Cancel',
    error: 'An error occurred, please retry',
    success: 'Your modifications have been saved',
    gender: 'Gender',
    firstname: 'First name',
    lastname: 'Last name',
    miss: 'Miss',
    mr: 'Mr.',
    mrs: 'Mrs.',
    nickname: 'Nickname',
    email: 'E-mail',
    confirm: 'Confirm e-mail',
    country: 'Country',
    save: 'Save',
    cancelEmailEdit: 'Cancel e-mail change',
    language: 'Language',
    languages: {
      ar: 'Arabic',
      en: 'English',
      fr: 'French',
      he: 'Hebrew',
      fa: 'Persian',
    },
    errors: {
      invalidEmail: 'Email field should be a valid email address',
      emailMismatch: 'Emails do not match',
    },
    mandatoryFields: 'Fields marked with * are mandatory',
  },
  french: {
    editProfile: 'Éditer le profil',
    cancel: 'Annuler',
    error: 'Une erreur est survenue, veuillez réessayer',
    success: 'Vos modifications ont été sauvegardées',
    gender: 'Genre',
    firstname: 'Prénom',
    lastname: 'Nom',
    miss: 'Mlle',
    mr: 'M',
    mrs: 'Mme',
    nickname: 'Pseudo',
    email: 'E-mail',
    confirm: 'Confirmation de l\'e-mail',
    country: 'Pays',
    save: 'Enregistrer',
    cancelEmailEdit: 'Annuler le changement d\'e-mail',
    language: 'Langue',
    languages: {
      ar: 'Arabe',
      en: 'Anglais',
      fr: 'Français',
      he: 'Hébreu',
      fa: 'Persan',
    },
    errors: {
      invalidEmail: 'Le champ e-mail doit être une adresse e-mail valide',
      emailMismatch: 'Les e-mails ne correspondent pas',
    },
    mandatoryFields: 'Les champs marqués d\'un * sont obligatoires',
  },
  arabic: {
    editProfile: 'تحرير البروفايل',
    cancel: 'الغاء',
    error: 'وقع خطأ يرجى اعادة المحاولة',
    success: 'تم حفظ التعديلات الخاصة بك',
    gender: 'جنس',
    firstname: 'الاسم الاول',
    lastname: 'اسم العائلة',
    miss: 'سيدة',
    mr: 'سيد',
    mrs: 'سيدة',
    nickname: 'الاسم المستعار',
    email: 'البريد الإلكتروني',
    confirm: 'تأكيد عنوان البريد الإلكتروني',
    country: 'بلد',
    save: 'حفظ',
    cancelEmailEdit: 'إلغاء تغيير البريد الإلكتروني',
    language: 'لغة',
    languages: {
      ar: 'عربى',
      en: 'الإنجليزية',
      fr: 'الفرنسية',
      he: 'اللغة العبرية',
      fa: 'الفارسية',
    },
    errors: {
      invalidEmail: 'يجب أن يكون حقل البريد الإلكتروني عنوان بريد إلكتروني صالح',
      emailMismatch: 'رسائل البريد الإلكتروني لا تتطابق',
    },
    mandatoryFields: 'الحقول التي تحمل علامة * إلزامية',
  },
  hebrew: {
    editProfile: 'ערוך פרופיל',
    cancel: 'בטל',
    error: 'אירעה שגיאה, אנא נסה שנית',
    success: 'השינויים שלך נשמרו',
    gender: 'מגדר',
    firstname: 'שם פרטי',
    lastname: 'שם משפחה',
    miss: 'גברת',
    mr: 'אדון',
    mrs: 'גברת',
    nickname: 'כינוי',
    email: 'כתובת דואר אלקטרוני',
    confirm: 'אשר כתובת דואר אלקטרוני',
    country: 'מדינה',
    save: 'נשמר',
    cancelEmailEdit: 'בטל שינוי כתובת דואר אלקטרוני',
    language: 'שפה',
    languages: {
      ar: 'ערבית',
      en: 'אנגלית',
      fr: 'צרפתית',
      he: 'עברית',
      fa: 'פרסית',
    },
    errors: {
      invalidEmail: 'כתובת האימייל לא תקינה',
      emailMismatch: 'כתובות האימייל לא מתאימות',
    },
    mandatoryFields: 'שדות המסומנים ב-* הם חובה',
  },
  persian: {
    editProfile: 'ویرایش نمایه',
    cancel: 'لغو کنید',
    error: 'خطایی روی داد، لطفا دوباره امتحان کنید',
    success: 'تغییرات شما ذخیره شده است',
    gender: 'جنسیت',
    firstname: 'نام کوچک',
    lastname: 'نام خانوادگی',
    miss: 'خانم',
    mr: 'آقای',
    mrs: 'خانم',
    nickname: 'نام مستعار',
    email: 'ایمیل',
    confirm: 'تایید ایمیل',
    country: 'کشور',
    save: 'ذخیره کنید',
    cancelEmailEdit: 'لغو تغییر ایمیل',
    language: 'زبان',
    languages: {
      ar: 'عربی',
      en: 'انگلیسی',
      fr: 'فرانسوی',
      he: 'عبری',
      fa: 'فارسی',
    },
    errors: {
      invalidEmail: 'فیلد ایمیل باید یک آدرس ایمیل معتبر باشد',
      emailMismatch: 'ایمیل ها مطابقت ندارند',
    },
    mandatoryFields: 'فیلدهایی که با * مشخص شده اند اجباری هستند',
  },
}
